export const CARACTERISTICA_PEDIDO_LOAD = "CARACTERISTICA_PEDIDO_LOAD";
export const CARACTERISTICA_PEDIDO_LIST = "CARACTERISTICA_PEDIDO_LIST";
export const CARACTERISTICA_PEDIDO_CREATE = "CARACTERISTICA_PEDIDO_CREATE";
export const CARACTERISTICA_PEDIDO_UPDATE = "CARACTERISTICA_PEDIDO_UPDATE";
export const CARACTERISTICA_PEDIDO_DELETE = "CARACTERISTICA_PEDIDO_DELETE";
